module.exports = __webpack_public_path__ + "media/images/badge/cecchino_secondary-bfa2430a29e2be1549fece9eab57bc0d.png";